import React, { useState, useEffect } from "react";

import {
  Box,
  Flex,
  Link,
  Text,
  useDisclosure,
  Button,
  useBreakpointValue,
  Icon,
  Tooltip,
  MenuButton,
  MenuList,
  MenuItem,
  Menu,
} from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";
import { Link as ReactLink, useHistory } from "react-router-dom";
import { TableRelatorioPendencia } from "../../../components/TableRelatorioPendencia";
import { BadgeCustom } from "../../../components/BadgeCustom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { RiFileExcel2Line } from "react-icons/ri";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { FiltersRelatorioCriancaAdolescente } from "../../../components/FiltersRelatorioCriancaAdolescente";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import {
  servicoAcolhimentoFunc,
  criancaFunc,
  dashboardFunc,
} from "../../../../helpers/Funcionalidades";
import Swal from "sweetalert2";
import RelatorioService from "../../../../main/services/RelatorioService";
import SemRegistros from "../../../components/SemRegistros";
import { PopoverGenero } from "../../../components/PopoverGenero";
import { PrintButtonRelatorioCrianca } from "../../../components/PrintButtonRelatorioCrianca";
import { useAuth } from "react-oidc-context";
import { formatDateToISOWithNow } from "../../../utils/formatDateToISOWithNow";

export const RelatoriosCriancaAdolescente = () => {
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ, usuarioLogado } = useAppContext();

  const history = useHistory();
  const auth = useAuth();

  const [mostrarTabela, setMostrarTabela] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintPreliminar, setHintPreliminar] = useState(false);
  const placement = useBreakpointValue({ md: "left" });
  const token = auth?.user?.access_token;

  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const storage = JSON.parse(
    sessionStorage.getItem("relatorio-crianca-adolescente-filter"),
  );

  const columns = [
    {
      Header: "Nome/Nome Social",
      accessor: "nomeCrianca",
      Cell: (props) => {
        const id = props?.row?.original?.idCrianca;
        let name = props?.row?.original?.nomeCrianca;
        const descricaoTipoSituacao =
          props?.row?.original?.descricaoTipoSituacao;
        const temRiscoVida =
          props?.row?.original?.riscoVida === "S" ? true : false;
        const idMovimento = props?.row?.original?.idMovimento;

        if (props?.row?.original?.nomeSocial) {
          name = name + " / " + props.row.original.nomeSocial;
        }

        return (roleKeycloack &&
          roleKeycloack.includes(criancaFunc.visualizar)) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM,
          ) ? (
          !temRiscoVida ? (
            <Link
              wordBreak={"break-all"}
              title={name}
              as={ReactLink}
              to={"/crianca/" + id}
            >
              <Flex alignItems="center" gap={2}>
                {descricaoTipoSituacao === "Acolhido" && idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          ) : (
            <Link
              wordBreak={"break-all"}
              title={name}
              onClick={() =>
                riscoAlert(
                  id,
                  props?.row?.original?.servicoAcolhimentoAtual
                    ?.idPessoaJuridica,
                  idMovimento,
                )
              }
            >
              <Flex alignItems="center" gap={2}>
                {descricaoTipoSituacao === "Acolhido" && idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : descricaoTipoSituacao === "Acolhido" ||
                  descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          )
        ) : !temRiscoVida ? (
          <Flex alignItems="center" gap={2}>
            {descricaoTipoSituacao === "Acolhido" ||
            descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        ) : (
          <Flex alignItems="center" gap={2}>
            {descricaoTipoSituacao === "Acolhido" ||
            descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        );
      },
    },
    {
      Header: "Gênero",
      accessor: "genero",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Data de Nascimento",
      accessor: "dataNascimento",

      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },

    {
      Header: "Idade",
      accessor: "idade",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
    {
      Header: "Filiação",
      accessor: "filiacoes",
      sortType: (rowA, rowB, id, desc) => {
        const filiacoesA = rowA?.original?.filiacoes?.length
          ? rowA.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        const filiacoesB = rowB?.original?.filiacoes?.length
          ? rowB.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        return filiacoesA.localeCompare(filiacoesB, "pt-BR");
      },
      Cell: (props) => {
        return props?.value
          .sort((a, b) =>
            a.descricaoTipoRelacionamento.localeCompare(
              b.descricaoTipoRelacionamento,
            ),
          )
          .map((filiacao, index) => {
            return (
              <React.Fragment key={index}>
                <span style={{ whiteSpace: "nowrap" }}>
                  {filiacao?.nome}{" "}
                  <Text as="span" textTransform="capitalize">
                    ({filiacao?.descricaoTipoRelacionamento.toLowerCase()})
                  </Text>
                </span>
                {props.value.length - 1 !== index && <br />}
              </React.Fragment>
            );
          });
      },
    },
    {
      Header: "Serviço de Acolhimento Atual",
      accessor: "servicoAcolhimentoAtual",
      sortType: (rowA, rowB, id, desc) => {
        const nomeServicoA = rowA?.original?.servicoAcolhimentoAtual
          ? rowA.original.servicoAcolhimentoAtual.nomeFantasia
          : "";
        const nomeServicoB = rowB?.original?.servicoAcolhimentoAtual
          ? rowB.original.servicoAcolhimentoAtual.nomeFantasia
          : "";
        return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
      },
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM,
          ) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.servicoAcolhimentoAtual?.idPessoaJuridica,
            ));
        const temRiscoVida =
          props?.row?.original?.riscoVida === "S" ? true : false;

        if (temRiscoVida && !permissaoServico) {
          return <span></span>;
        } else {
          const idServico = props?.row?.original?.servicoAcolhimentoAtual?.id;
          if (!idServico) {
            return <span></span>;
          } else {
            return (
              <>
                {roleKeycloack &&
                roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
                  <Link
                    wordBreak={"break-word"}
                    title={
                      props?.value
                        ? props?.value?.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""
                    }
                    as={ReactLink}
                    to={"/servico-acolhimento/" + idServico}
                  >
                    <Text>
                      {" "}
                      {props?.value
                        ? props?.value?.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""}
                    </Text>
                  </Link>
                ) : (
                  <Text>
                    {props?.value
                      ? props?.value?.nomeFantasia +
                        `${props?.value?.suspenso === "S" ? " (Suspenso)" : ""}`
                      : ""}
                  </Text>
                )}
              </>
            );
          }
        }
      },
    },
  ];

  const riscoAlert = (id, idPJCrianca, idMovimento) => {
    if (
      idMovimento !== 2 &&
      !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      history.push("/crianca/" + id);
    }
  };

  useEffect(() => {
    const storage = sessionStorage.getItem(
      "relatorio-crianca-adolescente-filter",
    );

    if (!storage && mostrarTabela) {
      setMostrarTabela(false);
    }
  }, [storage, mostrarTabela]);

  const renderizarTooltip = () => {
    if (isMobile)
      return (
        <PopoverGenero
          isOpen={hintPreliminar}
          setIsOpen={setHintPreliminar}
          flex={true}
          handleClick={() => setHintPreliminar(!hintPreliminar)}
          labelTextoGenero={
            "Durante o período pesquisado é possível que uma criança ou adolescente tenha mais de um movimento. Na versão Excel completo, o resultado da pesquisa exibirá todos esses movimentos."
          }
        />
      );

    return (
      <Tooltip
        label={
          "Durante o período pesquisado é possível que uma criança ou adolescente tenha mais de um movimento. Na versão Excel completo, o resultado da pesquisa exibirá todos esses movimentos."
        }
        fontSize="md"
        maxW="400px"
        textAlign={"justify"}
        placement={placement}
      >
        <span className="hint-tooltip">
          <Icon
            aria-label="Aviso de pendente"
            color="#6B6C71"
            as={IoHelpCircle}
            boxSize={{ base: "20px" }}
          />
        </span>
      </Tooltip>
    );
  };

  const getExportarExecel = async (tipo) => {
    const idsServicoAcolhimentoChange = roleKeycloack.includes(
      criancaFunc.visualizarTudoAcolhimento,
    )
      ? [storage?.idsServicosAcolhimento.value]
      : Array.isArray(storage?.idsServicosAcolhimento)
        ? storage?.idsServicosAcolhimento
            .flat()
            .map((item) => item.value)
            .filter((value) => value !== "")
        : [];

    const valuesToSend = {
      tipoRelatorio:
        tipo === "basico"
          ? "RELATORIO_CRIANCA_ADOLESCENTES_BASICO"
          : "RELATORIO_CRIANCA_ADOLESCENTES_COMPLETO",
      universoConsulta: storage?.universoConsulta
        ? storage?.universoConsulta?.label
            ?.normalize("NFD")
            ?.replace(/[\u0300-\u036f]/g, "")
            ?.toUpperCase()
        : "",
      idsServicosAcolhimento: storage?.idsServicosAcolhimento
        ? idsServicoAcolhimentoChange
        : [],
      dataInicio: storage?.dataInicio
        ? formatDateToISOWithNow(storage.dataInicio)
        : "",
      dataFim: storage?.dataFim ? formatDateToISOWithNow(storage.dataFim) : "",
      idsMotivosEntrada: storage?.idsMotivosEntrada
        ? storage?.idsMotivosEntrada
            .flat()
            .map((item) => item.id)
            .filter((id) => id !== "")
        : [],
      idTipoTransferencia: storage?.idTipoTransferencia
        ? storage?.idTipoTransferencia.id
        : "",
      idJustificativas: storage?.idJustificativas
        ? storage?.idJustificativas
            .flat()
            .map((item) => item.id)
            .filter((id) => id !== "")
        : [],
      tipoPeriodo: storage?.tipoPeriodo === "A" ? "SITUACAO_ATUAL" : "DATA",
      entradasPorTransferencias:
        Array.isArray(storage?.entradasPorTransferencias) &&
        storage.entradasPorTransferencias.includes("Possui"),

      maioresDezoito:
        Array.isArray(storage?.maioresDezoito) &&
        storage.maioresDezoito.includes("Possui"),
      saidaTransferencia:
        Array.isArray(storage?.saidaTransferencia) &&
        storage.saidaTransferencia.includes("Possui"),
    };

    try {
      setLoadingExcel(true);
      await RelatorioService.getExecelListaRelatorioCrianca(valuesToSend);

      Swal.fire({
        title: "Em processamento",
        html: `<div style="text-align: center;">Este relatório está sendo processado em segundo plano. <br /> Para acompanhar, verifique a sua fila de processamento localizado no <br /> menu lateral do sistema.</div>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Ir para Fila de Processamento",
        cancelButtonText: "Fechar",
        width: "600px",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/fila-processamento");
        }
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error?.response?.data?.message : "",
        icon: "error",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const [data, setData] = useState();
  const isDisabled = loadingExcel || !data?.content?.length;

  return roleKeycloack &&
    roleKeycloack?.includes(dashboardFunc.relatorioCriancaAdolescente) ? (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Group
        mt={1}
        title={"Relatório de Crianças e Adolescentes"}
        opcoes={true}
        dividerFalse={true}
      >
        <>
          {!mostrarTabela && (
            <Box mt={4}>
              <FiltersRelatorioCriancaAdolescente
                data={data}
                setData={setData}
                setLoading={setLoading}
                loading={loading}
                entidade="relatorio-crianca-adolescente"
                user={user}
                roleKeycloack={roleKeycloack}
                atualizarDadosTabela={atualizarDadosTabela}
                setAtualizarDadosTabela={setAtualizarDadosTabela}
                setMostrarTabela={setMostrarTabela}
              />
            </Box>
          )}

          {mostrarTabela && (
            <>
              {!loading && data ? (
                <>
                  <Text
                    mt={6}
                    fontWeight={700}
                    fontSize="16px"
                    lineHeight="136%"
                    color={`#169499`}
                  >
                    Resultado da Busca:
                  </Text>

                  <Flex
                    mt={4}
                    alignItems="center"
                    gap={2}
                    flexWrap="wrap"
                    maxWidth="100%"
                  >
                    <BadgeCustom
                      title={"Serviço de Acolhimento:"}
                      description={
                        storage?.idsServicosAcolhimento?.length
                          ? storage?.idsServicosAcolhimento
                              ?.flat()
                              ?.map((item) => item.label)
                              ?.join("; ")
                          : storage?.idsServicosAcolhimento?.label || "Todos"
                      }
                    />
                    <BadgeCustom
                      title={"Universo da Consulta:"}
                      description={storage?.universoConsulta?.label || "Todos"}
                    />

                    {storage?.universoConsulta?.id === 3 && (
                      <BadgeCustom
                        title="Tipo de Transferência:"
                        description={
                          storage?.idTipoTransferencia?.label || "Todos"
                        }
                      />
                    )}

                    {((storage?.universoConsulta?.id === 3 &&
                      (storage?.idTipoTransferencia?.id === 2 ||
                        storage?.idTipoTransferencia?.id === 6)) ||
                      storage?.universoConsulta?.id === 4) && (
                      <BadgeCustom
                        title="Justificativa:"
                        description={
                          (storage?.idJustificativas?.length &&
                            storage?.idJustificativas
                              ?.flat()
                              ?.map((item) =>
                                item.descricao?.replace(/\.$/, ""),
                              )
                              ?.join("; ")) ||
                          "Todos"
                        }
                      />
                    )}

                    {(storage?.universoConsulta?.id === 1 ||
                      storage?.universoConsulta?.id === 2) && (
                      <BadgeCustom
                        title="Motivo:"
                        description={
                          (storage?.idsMotivosEntrada?.length &&
                            storage?.idsMotivosEntrada
                              ?.flat()
                              ?.map((item) => item.descricao)
                              ?.join("; ")) ||
                          "Todos"
                        }
                      />
                    )}

                    {storage?.tipoPeriodo === "A" ? (
                      <BadgeCustom
                        title={"Período:"}
                        description={"Situação Atual"}
                      />
                    ) : (
                      <Flex gap={4}>
                        {storage?.dataInicio && (
                          <BadgeCustom
                            title={"Período de:"}
                            description={storage?.dataInicio || ""}
                          />
                        )}

                        {storage?.dataFim && (
                          <BadgeCustom
                            title={"Até:"}
                            description={storage?.dataFim || ""}
                          />
                        )}
                      </Flex>
                    )}

                    {(storage?.entradasPorTransferencias?.includes("Possui") ||
                      storage?.saidaTransferencia?.includes("Possui") ||
                      storage?.maioresDezoito?.includes("Possui")) && (
                      <BadgeCustom
                        title="Deseja Incluir:"
                        description={
                          [
                            storage?.entradasPorTransferencias?.includes(
                              "Possui",
                            ) && "Entradas por Transferências",
                            storage?.saidaTransferencia?.includes("Possui") &&
                              "Saídas por Transferências",
                            storage?.maioresDezoito?.includes("Possui") &&
                              (storage?.universoConsulta?.id === 4
                                ? "Os Maiores de 18 Anos que Não se Encontram na Situação de Pendente"
                                : "Maiores de 18 Anos"),
                          ]
                            .filter(Boolean)
                            .join("; ") || ""
                        }
                      />
                    )}
                  </Flex>

                  <Flex mt={4} alignItems="center" justifyContent="end" gap={4}>
                    <PrintButtonRelatorioCrianca
                      user={user}
                      token={token}
                      entidade={"relatorio-crianca-adolescente"}
                      dados={usuarioLogado}
                      roleKeycloack={roleKeycloack}
                    />
                    {/* <Flex
                      alignItems="center"
                      gap={2}
                      cursor={isDisabled ? "not-allowed" : "pointer"}
                      pointerEvents={isDisabled ? "none" : "auto"}
                      onClick={() => !isDisabled && getExportarExecel()}
                    >
                      <Flex
                        bg={isDisabled ? "#A9A9A9" : "#006400"}
                        rounded="full"
                        p={1}
                      >
                        <RiFileExcel2Line color="white" />
                      </Flex>

                      <Text
                        as="b"
                        color={isDisabled ? "#A9A9A9" : "#006400"}
                        fontSize={"md"}
                      >
                        Exportar em Excel
                      </Text>
                    </Flex> */}
                    <Menu>
                      {({ isOpen }) => (
                        <>
                          <MenuButton
                            cursor={isDisabled ? "not-allowed" : "pointer"}
                            pointerEvents={isDisabled ? "none" : "auto"}
                          >
                            <Flex alignItems="center" gap={2}>
                              <Flex
                                bg={isDisabled ? "#A9A9A9" : "#006400"}
                                rounded="full"
                                p={1}
                              >
                                <RiFileExcel2Line color="white" />
                              </Flex>

                              <Text
                                as="b"
                                color={isDisabled ? "#A9A9A9" : "#006400"}
                                fontSize="md"
                              >
                                Exportar em Excel
                              </Text>

                              {!isDisabled && (
                                <Icon
                                  as={ChevronDownIcon}
                                  color="#006400"
                                  boxSize={6}
                                  transition="transform 0.2s"
                                  transform={
                                    isOpen ? "rotate(180deg)" : "rotate(0deg)"
                                  }
                                />
                              )}
                            </Flex>
                          </MenuButton>

                          <MenuList>
                            <MenuItem
                              cursor={"pointer"}
                              pr={6}
                              py={3}
                              justifyContent="space-between"
                              as="strong"
                              onClick={() =>
                                !isDisabled && getExportarExecel("basico")
                              }
                            >
                              Básico <FaDownload color="#006064" size={16} />
                            </MenuItem>
                            <MenuItem
                              cursor={"pointer"}
                              pr={6}
                              py={3}
                              justifyContent="space-between"
                              as="strong"
                              onClick={() =>
                                !isDisabled && getExportarExecel("completo")
                              }
                            >
                              Completo <FaDownload color="#006064" size={16} />
                            </MenuItem>
                          </MenuList>
                        </>
                      )}
                    </Menu>
                    {(storage?.tipoPeriodo === "D" ||
                      storage?.dataInicio ||
                      storage?.dataFim) && <> {renderizarTooltip()} </>}
                  </Flex>

                  <TableRelatorioPendencia
                    data={data.content}
                    columns={columns}
                    isOpenNovoAcolhimento={isOpenNovoAcolhimento}
                    onOpenNovoAcolhimento={onOpenNovoAcolhimento}
                    onCloseNovoAcolhimento={onCloseNovoAcolhimento}
                    entidade="relatorio-crianca-adolescente"
                    atualizarDadosTabela={atualizarDadosTabela}
                    setAtualizarDadosTabela={setAtualizarDadosTabela}
                    roleKeycloack={roleKeycloack}
                    user={user}
                    setData={setData}
                    idPJ={idPJ}
                  />

                  <Flex
                    w={"full"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    mt={4}
                  >
                    <Button
                      type="button"
                      translate="no"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      w={"100%"}
                      maxW={{ base: "100%", md: "50%", lg: "13%" }}
                      onClick={() => {
                        setMostrarTabela(false);
                        sessionStorage.removeItem("mostrarTabelaRelatorio");
                        sessionStorage.removeItem(
                          "relatorio-crianca-adolescente-filter",
                        );
                      }}
                    >
                      Nova Pesquisa
                    </Button>
                  </Flex>
                </>
              ) : (
                <Box mt={4}>
                  <LoadingSpinner />
                </Box>
              )}
            </>
          )}
        </>
      </Group>
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
